import { memo } from 'react';

import { ComponentContextProps, merge, useComponent } from '@/components';
import { DivProps } from '@/utils';

export type IndicatorProps = DivProps & Partial<ComponentContextProps>;

const IIndicator = ({ className, variant, ...rest }: IndicatorProps) => {
  const context = useComponent({ variant });

  let bgColor;
  switch (context.variant) {
    case 'success':
      bgColor = 'bg-success-500';
      break;
    case 'warning':
      bgColor = 'bg-warning-500';
      break;
    case 'error':
      bgColor = 'bg-error-500';
      break;
    default:
      bgColor = 'bg-gray-500';
  }

  return <div className={merge('rounded-2xs size-2', bgColor, className)} {...rest} />;
};

export const Indicator = memo(IIndicator) as typeof IIndicator;

export type CellProps = DivProps;

const ICell = ({ className, children, ...rest }: CellProps) => {
  return (
    <div
      className={merge(
        'flex size-8 items-center justify-center rounded-sm border-1 border-gray-200 bg-gray-50 p-1 shadow-xs',
        className
      )}
      role="button"
      {...rest}
    >
      {children}
    </div>
  );
};

export const Cell = memo(ICell) as typeof ICell;

export type IndentedDiv = DivProps;

const IIndentedDiv = ({ className, children, ...rest }: IndentedDiv) => {
  return (
    <div className={merge('ml-md flex w-fit rounded-xs bg-gray-700 px-1', className)} {...rest}>
      {children}
    </div>
  );
};

export const IndentedDiv = memo(IIndentedDiv) as typeof IIndentedDiv;
